import util from "@/common/util";
import service from "./service";

// 전체 프로젝트 진행률
function getTotalProjectProgress(payload) {
  try {
    const res = service.getTotalProjectProgress(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 전체 작업 진행률
function getTotalWorkProgress(payload) {
  try {
    const res = service.getTotalWorkProgress(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 작업 상태별 파일수 (프로젝트)
function getTaskStatusProgressProject(payload) {
  try {
    const res = service.getTaskStatusProgressProject(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 작업 상태별 파일수 (작업)
function getTaskStatusProgressWork(payload) {
  try {
    const res = service.getTaskStatusProgressWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 일별 작업 현황(프로젝트)
function getDailyWorkloadProject(payload) {
  try {
    const res = service.getDailyWorkloadProject(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 일별 작업 현황(작업)
function getDailyWorkloadWork(payload) {
  try {
    const res = service.getDailyWorkloadWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 작업별 진행률
function getTaskProgress(payload) {
  try {
    const res = service.getTaskProgress(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 할당량 달성 현황 (프로젝트)
function getPersonalAchievementProject(payload) {
  try {
    const res = service.getPersonalAchievementProject(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 할당량 달성 현황 (작업)
function getPersonalAchievementWork(payload) {
  try {
    const res = service.getPersonalAchievementWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 작업 상태별 파일 수 (프로젝트)
function getConciseStatusProject(payload) {
  try {
    const res = service.getConciseStatusProject(payload);

    return res;
  } catch (error) {
    console.log(error);
  }
}

// 작업 상태별 파일 수 (작업)
function getConciseStatusWork(payload) {
  try {
    const res = service.getConciseStatusWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 클래스 객체 영역 (프로젝트)
function getResultClassProject(payload) {
  try {
    const res = service.getResultClassProject(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 클래스 객체 영역 (작업)
function getResultClassWork(payload) {
  try {
    const res = service.getResultClassWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 클래스 선택 시 Attribute
function getClassAttributeResult(payload) {
  try {
    const res = service.getClassAttributeResult(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// Attribute 영역 (프로젝트)
function getResultAttributeProject(payload) {
  try {
    const res = service.getResultAttributeProject(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// Attribute 영역 (작업)
function getResultAttributeWork(payload) {
  try {
    const res = service.getResultAttributeWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// ----------------------- 작업 현황 시작
function getStatusItems(payload) {
  try {
    const res = service.getStatusItems(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function getStatusItemsExcel(payload) {
  return new Promise((resolve, reject) => {
    service
      .getStatusItemsExcel(payload)
      .then((res) => {
        const name = "작업현황_Result_" + util.datetimeFormat(new Date());
        const ext = `.${payload.fileType}`;
        const filename = name + ext;
        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getStatusFilterPeople(payload) {
  try {
    const res = service.getStatusFilterPeople(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

/**
 * getStatusFilterTask
 * @param {object} payload
 * @param {string} payload.pid
 */
async function getStatusFilterTask(payload) {
  try {
    const res = await service.getStatusFilterTask(payload);
    return res;
  } catch (error) {
    return null;
  }
}

// ----------------------- 작업 현황 끝

// 일괄 검수 (프로젝트)
function isBatchInspectionProject(pId) {
  try {
    const res = service.isBatchInspectionProject(pId);
    return res;
  } catch (error) {
    console.log(error);
  }
}
function setBatchInspectionProject(tId) {
  try {
    const res = service.setBatchInspectionProject(tId);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 일괄 검수 (작업)
function isBatchInspectionWork(payload) {
  try {
    const res = service.isBatchInspectionWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}
function setBatchInspectionWork(payload) {
  try {
    const res = service.setBatchInspectionWork(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function getManagerItemExcel(payload) {
  const ext = payload.type === "PROJECT" ? ".tar.gz" : ".csv";

  return new Promise((resolve, reject) => {
    service
      .getManagerItemExcel(payload)
      .then((res) => {
        const name = "담당자_Result_" + util.datetimeFormat(new Date());
        // const ext = `.${payload.fileType}`;
        const filename = name + ext;

        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function downloadExcel(res, filename) {
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  link.style.cssText = "display: none";
  document.body.appendChild(link);
  link.click();
  link.remove();
}

// ----------------------- 담당자 시작
function getDashBoardManager(payload) {
  try {
    const res = service.getDashBoardManager(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function updateTaskAllocate(payload) {
  try {
    const res = service.updateTaskAllocate(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function getOpTotalProjectProgress(payload) {
  try {
    const res = service.getOpTotalProjectProgress(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function getOpTotalTaskProgress(payload) {
  try {
    const res = service.getOpTotalTaskProgress(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

/** get projects (dashboard left panel) */
function getDashboardProjects(payload) {
  try {
    const res = service.getDashboardProjects(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

/** get tasks (dashboard left panel) */
function getDashboardTasks(payload) {
  try {
    const res = service.getDashboardTasks(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function getAllocates(payload) {
  try {
    const res = service.getAllocates(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

function patchAllocates(params, body) {
  try {
    const res = service.patchAllocates(params, body);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// ----------------------- 담당자 종료

export default {
  getTotalProjectProgress,
  getTotalWorkProgress,
  getTaskStatusProgressProject,
  getTaskStatusProgressWork,
  getDailyWorkloadProject,
  getDailyWorkloadWork,
  getTaskProgress,
  getPersonalAchievementProject,
  getPersonalAchievementWork,
  getConciseStatusProject,
  getConciseStatusWork,
  getResultClassProject,
  getResultClassWork,
  getClassAttributeResult,
  getResultAttributeProject,
  getResultAttributeWork,
  getStatusItems,
  getStatusItemsExcel,
  isBatchInspectionProject,
  setBatchInspectionProject,
  isBatchInspectionWork,
  setBatchInspectionWork,
  getStatusFilterPeople,
  getDashBoardManager,
  updateTaskAllocate,
  getManagerItemExcel,
  getOpTotalProjectProgress,
  getOpTotalTaskProgress,
  getStatusFilterTask,
  getAllocates,
  patchAllocates,
  getDashboardProjects,
  getDashboardTasks,
};
